export const contactsIsComplete = (orgUnitAthleteEntryInfoStateObjData) => {
    if (orgUnitAthleteEntryInfoStateObjData.hasEntryContact === false && orgUnitAthleteEntryInfoStateObjData.teamOrgUnitName === 'Unattached') {
        return false;
    }

    return true;
};

export const rosterEntriesIsComplete = (orgUnitAthleteEntryInfoStateObjData) => {
    if (orgUnitAthleteEntryInfoStateObjData.hasApprovedEvents === false && orgUnitAthleteEntryInfoStateObjData.teamOrgUnitName === 'Unattached') {
        return false;
    }

    return true;
};

export const credentialsIsComplete = (orgUnitAthleteEntryInfoStateObjData) => {
    if (orgUnitAthleteEntryInfoStateObjData.credentialsAmountAllowed === false && orgUnitAthleteEntryInfoStateObjData.teamOrgUnitName === 'Unattached') {
        return false;
    }

    return true;
};

export const submitIsComplete = () => {
    return true;
};